import ToggleSwitch from "components/toggle-switch";
import { Form } from "react-bootstrap";
import styles from "./AutoDelete.module.scss";
import getClasses from "utils/getClasses";
import { AmplitudePageName, track } from "utils/amplitude";
import CustomSelect from "components/custom-select/CustomSelect";
import { DAYS_OPTIONS_FOR_AUTO_DELETE } from "components/provider-intake/utility/constants";
const AMPLITUDE_PAGE_NAME: AmplitudePageName = "pro-settings-ai";

type AutoDeleteTranscriptTypes = {
  autoDeleteAfterDays: number;
  setAutoDeleteAfterDays: React.Dispatch<React.SetStateAction<number>>;
  autoDeleteTranscript: boolean;
  setChanged: React.Dispatch<React.SetStateAction<boolean>>;
  setAutoDeleteTranscript: React.Dispatch<React.SetStateAction<boolean>>;
};

const AutoDeleteTranscript = ({
  autoDeleteAfterDays,
  setAutoDeleteAfterDays,
  autoDeleteTranscript,
  setChanged,
  setAutoDeleteTranscript,
}: AutoDeleteTranscriptTypes) => {
  return (
    <div className={styles["ai-setting__auto-delete"]}>
      <div className={styles["ai-setting__section-title"]}>
        Automatically Delete Transcription
      </div>
      <div className={getClasses("mb-0", styles["ai-setting__toggle"])}>
        <ToggleSwitch
          checked={autoDeleteTranscript}
          onChange={(e) => {
            setChanged(true);
            setAutoDeleteTranscript(e.target.checked);
          }}
          onClick={() =>
            track(AMPLITUDE_PAGE_NAME, "auto-delete-transcript", "click")
          }
        />
        <span aria-hidden="true" className={styles.textBox}>
          Automatically{" "}
          <b>delete transcripts after {autoDeleteAfterDays} days</b> of the
          session processing being completed. This will disable swapping note
          types and the generation of treatment plans and goals.
        </span>
      </div>

      {autoDeleteTranscript && (
        <Form.Group className={styles["ai-setting__select-days"]}>
          <CustomSelect
            options={DAYS_OPTIONS_FOR_AUTO_DELETE}
            onChange={(el) => {
              setChanged(true);
              setAutoDeleteAfterDays(el.value);
            }}
            required
            value={DAYS_OPTIONS_FOR_AUTO_DELETE.find(
              (option) => option.value === autoDeleteAfterDays,
            )}
          />
        </Form.Group>
      )}
    </div>
  );
};

export default AutoDeleteTranscript;
